// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_ePC","cls2":"Header-cls2__Pr Header-cls1_ePC"};